export enum AppPaths {
  Access = 'access',
  Account = 'account',
  Admin = 'admin',
  AuditLog = 'audit-log',
  CourtroomDisplay = 'display',
  CourtroomJoin = 'public/court-system/:courtSystemId/locations/:courthouseId/locations/:courtroomId/join',
  CourtroomJoinDetail = 'public/court-system/:courtSystemId/locations/:courthouseId/locations/:courtroomId/join-detail',
  CourtSystemForbidden = 'court-system-forbidden',
  CourtSystem = 'court-system',
  CourtSystems = 'court-systems',
  DefaultPage = '',
  DesignSystem = 'design-system',
  ExternalLogin = 'external-login',
  Forbidden = 'forbidden',
  Help = 'help',
  Jobs = 'jobs',
  Login = 'login',
  DesktopLoginSplash = 'desktop-login-splash',
  DesktopUpdateSplash = 'desktop-update-splash',
  Logout = 'logout',
  MultiFactorAuthentication = 'multifactor-authentication',
  NotFound = 'not-found',
  Organizations = 'organizations',
  Orders = 'orders',
  Recording = 'recording',
  ReportExport = 'report-export',
  ReportPrint = 'report-print',
  Request = 'request',
  SharedRecordings = 'shared-recordings',
  SharedWithMe = 'shared-with-me',
  StandaloneAppDownload = 'download',
  PricingPlans = 'pricing-plans',
  SelectPlanType = 'select-plan-type',
  SelectPlanTier = 'select-plan-tier',
  Styles = 'styles',
  Transcripts = 'transcripts',
  Locations = 'locations',
}
